import {intersection} from "lodash/array";
import {Kind} from "graphql";
import {GraphQLUpload} from "graphql-upload";

export const fileProps = ['path', 'filename', 'mimetype', 'encoding', 'size']

export const hasFileProps = (node) => {
    // TODO make more precise duck-type check
    return intersection(node.fields.map(({name: {value}}) => value), fileProps).length === fileProps.length;
};

export const visitor = (node) => {
    if (node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION && hasFileProps(node)) {
        node.fields = node.fields.filter(f => !fileProps.includes(f.name.value))
        node.fields.push({
            kind: Kind.INPUT_VALUE_DEFINITION,
            description: undefined,
            name: { kind: 'Name', value: 'upload' },
            type: { kind: 'NamedType', name:  { kind: 'Name', value: GraphQLUpload.name } },
            defaultValue: undefined,
            directives: []
        })
    }
    return node;
};


export default visitor;
